/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'user-circle': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M22.5 12c0 5.799-4.701 10.5-10.5 10.5S1.5 17.799 1.5 12 6.201 1.5 12 1.5 22.5 6.201 22.5 12zm1.5 0c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12zm-12-1.085a3.125 3.125 0 100-6.25 3.125 3.125 0 000 6.25zm0 1.5a4.625 4.625 0 100-9.25 4.625 4.625 0 000 9.25zm-3.91 3.497c-.975.73-1.507 1.682-1.507 2.67a.75.75 0 01-1.5 0c0-1.566.848-2.927 2.106-3.87 1.258-.944 2.961-1.505 4.811-1.505s3.553.561 4.81 1.504c1.259.944 2.107 2.305 2.107 3.871a.75.75 0 11-1.5 0c0-.988-.532-1.94-1.506-2.67-.974-.731-2.355-1.205-3.911-1.205s-2.937.474-3.91 1.204z" _fill="#000"/>'
  }
})
